
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 6a2 2 0 012-2h7a2 2 0 012 2v13H5V6z","fill":"#fff","stroke":"#BABABA","stroke-width":"2"}}),_c('path',{attrs:{"d":"M12 12a1 1 0 011-1h5a1 1 0 011 1v7h-7v-7z","fill":"#fff","stroke":"#BABABA","stroke-width":"2"}}),_c('path',{attrs:{"d":"M8 12h1M8 16h1M15 16h1M8 8h1M12 8h1","stroke":"#BABABA","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    